import { getPersonName } from 'utils/details';
import {
  BASE_EVENT_STATUS,
  eventDistributionOptions,
  eventDistributionOptionsForSupervisor,
  eventPublicDistribution,
} from 'utils/constants/eventStatus';
import { ROLES } from 'utils/constants/roles';
import eventCategories from 'static/event_categories_types.json';
import isEmpty from 'lodash/isEmpty';
import API from 'services/api';
import { createError } from 'reducers/ui';
import { errorHandler } from 'utils/errorMessages';

export const checkUserRole = (userRole, qualifiedRole) => {
  const hasUserRole = userRole.some(role => qualifiedRole.includes(role));
  return hasUserRole;
};

export const checkEventStatus = (event, publishStatus) => {
  const hasEventStatus = publishStatus.includes(
    event.generalInfo.publishStatus.value,
  );
  return hasEventStatus;
};

export const allResponderAndSupervisor = eventAssignee => {
  return eventAssignee.map(assignee => ({
    id: assignee.general.id,
    label: getPersonName(assignee.general),
  }));
};

export const omitPublicDistribution = ({
  eventCategory,
  availableServices,
}) => {
  const categoryInfo = eventCategories.find(
    item => item.category === eventCategory,
  );
  // ommit public distribution if the event category does not have a specific service and deprecated key should not exist
  if (
    categoryInfo.services &&
    !Object.prototype.hasOwnProperty.call(categoryInfo, 'deprecated')
  ) {
    const hasService = categoryInfo.services.some(s =>
      availableServices.includes(s),
    );
    return !hasService; // if the event catgegory has service then public distribution option is set
  } else if (
    !Object.prototype.hasOwnProperty.call(categoryInfo, 'services') && // if both services and deprecated option are missing then it has public distribution option
    !Object.prototype.hasOwnProperty.call(categoryInfo, 'deprecated')
  ) {
    return false; // false will make sure that the category has public distribution option
  }
  return false;
};

export const getDistributionOptions = (
  loggedInUserRole,
  eventCategory,
  availableServices,
) => {
  const omitPublicDistributionOption = omitPublicDistribution({
    eventCategory,
    availableServices,
  });
  if (
    checkUserRole(loggedInUserRole, [
      ROLES.MANAGER.id,
      ROLES.SECURITY_COMPANY_MANAGER.id,
    ])
  ) {
    return [
      ...eventDistributionOptions,
      ...(omitPublicDistributionOption ? [] : eventPublicDistribution),
    ];
  } else if (checkUserRole(loggedInUserRole, [ROLES.SUPERVISOR.id])) {
    return eventDistributionOptionsForSupervisor;
  }
  return [];
};

export const checkUserRoleAndEventStatus = ({
  userRoles,
  qualifiedUserRoles,
  event,
  qualifiedEventStatus,
}) => {
  const userhasQualifiedRole = checkUserRole(userRoles, qualifiedUserRoles);
  const eventHasQualifiedStatus = checkEventStatus(event, qualifiedEventStatus);
  return userhasQualifiedRole && eventHasQualifiedStatus;
};

export const checkQualification = ({
  userRoles,
  qualifiedUserRoles,
  event,
  qualifiedEventStatus,
  eventDist,
}) => {
  const isUserQualified = checkUserRoleAndEventStatus({
    userRoles,
    qualifiedUserRoles,
    event,
    qualifiedEventStatus,
  });
  if (userRoles.includes(ROLES.SUPERVISOR.id)) {
    const isDistInternal = eventDist === BASE_EVENT_STATUS.INTERNAL.value;
    return isUserQualified && isDistInternal;
  } else {
    return isUserQualified;
  }
};

export const getEventCategoryByProduct = (products = []) => {
  const categories = eventCategories.reduce((acc, current) => {
    const { category, products: eventProducts, deprecated } = current;
    if (
      !isEmpty(eventProducts) &&
      !products.some(item => eventProducts.includes(item))
    ) {
      return acc;
    }

    return deprecated ? acc : [...acc, category];
  }, []);

  return categories;
};

export const fetchFollowupEvent = async event => {
  try {
    const { data } = !isEmpty(event)
      ? await API.fetchEventDetails(event.general.id)
      : event;
    return { ...data.data };
  } catch (e) {
    createError(errorHandler(e));
    return e;
  }
};
